import { FC, useState, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

interface CollapsibleContainerProps {
  children: ReactNode;
  // Posiciones del botón
  topExpanded?: string;
  topCollapsed?: string;
  rightExpanded?: string;
  rightCollapsed?: string;
  // Colores
  iconColor?: string;
  iconColorHover?: string;
  backgroundColor?: string;
  boxShadow?: string;
  boxShadowHover?: string;
  iconShadowHover?: string;
  // Tamaños
  buttonSize?: string;
  iconSize?: string;
  maxHeight?: string;
  // Duración de animación
  transitionDuration?: string;
  // Clases adicionales
  className?: string;
  contentClassName?: string;
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
}

const CollapsibleContainer: FC<CollapsibleContainerProps> = ({
  children,
  topExpanded = '10px',
  topCollapsed = '5px',
  rightExpanded = '30px',
  rightCollapsed = '0px',
  iconColor = '#005DFA',
  iconColorHover = '#005DFA',
  backgroundColor = 'white',
  boxShadow = '0 0 4px rgba(0,93,250,0.4)',
  boxShadowHover = '0 0 8px rgba(0,93,250,0.6)',
  iconShadowHover = 'drop-shadow(0 0 1px rgba(0,93,250,0.5))',
  buttonSize = '32px',
  iconSize = '16px',
  maxHeight = '500px',
  transitionDuration = '0.3s',
  className = '',
  contentClassName = '',
  isExpanded = true,
  setIsExpanded = (isExpanded: boolean) => {}
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className={`shadow-sm relative ${className}`}>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          position: 'absolute',
          top: isExpanded ? topExpanded : topCollapsed,
          right: isExpanded ? rightExpanded : rightCollapsed,
          zIndex: 10,
          backgroundColor,
          boxShadow: isHovered ? boxShadowHover : boxShadow,
          cursor: 'pointer',
          borderRadius: '50%',
          width: buttonSize,
          height: buttonSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: `all ${transitionDuration} ease-in-out`
        }}
      >
        <FontAwesomeIcon
          icon={faChevronUp}
          color={isHovered ? iconColorHover : iconColor}
          style={{
            fontSize: iconSize,
            filter: isHovered ? iconShadowHover : 'none',
            transition: `all ${transitionDuration} ease-in-out`,
            transform: `rotate(${isExpanded ? 180 : 0}deg) scale(${
              isHovered ? 1.2 : 1
            })`
          }}
        />
      </div>
      <div
        style={{
          maxHeight: isExpanded ? maxHeight : '0',
          overflow: 'hidden',
          transition: `max-height ${transitionDuration} ease-in-out`
        }}
      >
        <div className={contentClassName}>{children}</div>
      </div>
    </div>
  );
};

export default CollapsibleContainer;

